/* FDP Carte cadeau — sélecteur de montant (variantes du produit) + ajout au panier (vanilla) */
(function () {
  function showToast(msg, isErr) {
    if (!document.querySelector('.quick-add-toast-styles')) {
      var st = document.createElement('style');
      st.className = 'quick-add-toast-styles';
      st.textContent = '.quick-add-toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(20px);z-index:2147483647;background:#31af54;color:#fff;font-size:14px;font-weight:600;padding:12px 24px;border-radius:999px;box-shadow:0 4px 20px rgba(0,0,0,.12);opacity:0;animation:quickAddToastIn .3s ease forwards,quickAddToastOut .3s ease 2.2s forwards;pointer-events:none}.quick-add-toast--error{background:#dc2626}@keyframes quickAddToastIn{to{opacity:1;transform:translateX(-50%) translateY(0)}}@keyframes quickAddToastOut{to{opacity:0;transform:translateX(-50%) translateY(10px)}}';
      document.head.appendChild(st);
    }
    var t = document.createElement('div');
    t.className = 'quick-add-toast' + (isErr ? ' quick-add-toast--error' : '');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 2600);
  }

  // Textes traduits exposés par snippets/js-variables.liquid (fallback FR)
  var STRINGS = (window.themeVariables && window.themeVariables.strings) || {};
  var TOAST_ADDED = STRINGS.toastAddedToCart || 'Ajouté au panier';
  var TOAST_ADD_ERROR = STRINGS.toastAddError || 'Erreur lors de l’ajout';

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          if (c.item_count > 0) el.removeAttribute('hidden');
        });
      });
  }

  function initSelector(selector) {
    if (selector.dataset.fdpReady) return;
    selector.dataset.fdpReady = '1';

    var cardId = selector.dataset.card;
    var card = cardId ? document.getElementById(cardId) : null;
    var cardAmount = card ? card.querySelector('[data-fdp-giftcard-amount]') : null;
    var offerLabel = selector.querySelector('[data-fdp-offer-amount]');
    var buttons = selector.querySelectorAll('.fdp-gc__amount[data-variant-id]');
    var cta = selector.querySelector('.fdp-gc__cta');

    buttons.forEach(function (btn) {
      if (btn.disabled) return;
      btn.addEventListener('click', function () {
        var value = btn.dataset.amount;
        selector.dataset.selectedVariant = btn.dataset.variantId;
        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        if (cardAmount) cardAmount.textContent = value;
        if (offerLabel) offerLabel.textContent = value;
      });
    });

    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = parseInt(selector.dataset.selectedVariant, 10);
        if (!variantId) return;
        cta.disabled = true;
        // URL localisée : les messages d'erreur de l'API panier sont renvoyés dans la langue courante
        fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || TOAST_ADD_ERROR); });
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            refreshCartCount();
            showToast(TOAST_ADDED, false);
          })
          .catch(function (err) {
            showToast(err.message || TOAST_ADD_ERROR, true);
          })
          .then(function () { cta.disabled = false; });
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-fdp-gc-selector]').forEach(initSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
